<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">留言管理</span>
      </div>
    </div>
    <div class="tab">
      <div class="tabLeft">
        <div class="tabBox"
             :style="tabIndex==1?'background: #0B8586;color:#fff':''">
          <span>消息</span>
        </div>
        <!-- <div class="tabBox"
             @click="toworks"
             :style="tabIndex==2?'background: #0B8586;color:#fff':''">
          <span>评论</span>
        </div> -->
      </div>
    </div>
    <div class="list">
      <div class="box"
           v-for="(item,index) in storeList"
           :key="index">
        <div class="boxleft">
          <div class="blbox1">
            <img :src="item.avatarUrl"
                 alt="">
          </div>
          <div class="blbox">
            <span class="nicheng">{{item.nickname}}</span>
            <span class="neirong">{{item.mMessage}}</span>
            <div class="blboxbot">
              <span style="color: #ADADAD;">{{item.mAddTime}}</span>
              <div class="caozuo">
                <div class="caozuo"
                     @click="tohuifu(item.mId,item.mSendUserID,index)"
                     style="cursor: pointer;">
                  <img src="../../assets/img/icon/huifu.png"
                       alt="">
                  <span>回复（{{item.replyList.length}}）</span>
                </div>
                <div class="caozuo"
                     style="cursor: pointer;margin-left: 20px;"
                     @click="shanchu(item.mId)">
                  <img src="../../assets/img/icon/shanchu2.png"
                       alt="">
                  <span>删除</span>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="boxright"
             v-if="item.mImageResUrl">
          <img :src="item.mImageResUrl.split(',')[0]"
               v-if="item.mImageResUrl.split(',')[0]"
               alt="">
          <img :src="item.mImageResUrl.split(',')[1]"
               v-if="item.mImageResUrl.split(',')[1]"
               alt="">
        </div>
        <div class="hfbox"
             v-show="isHuifuNum==index">
          <div v-for="(items,index) in item.replyList"
               :key="index+'s'"
               class="hfboxs">
            <p>
              <span>回复</span>
              <span style="color:#0b8586">{{item.nickname}}</span>
              <span>：{{items.mMessage}}</span>

            </p>
            <span style="margin-right: 60px;">{{items.mAddTime}}</span>
          </div>

          <textarea v-model="huifu"
                    placeholder="输入您要回复的内容"></textarea>
          <div class="zishu">
            <span :style="huifu.length>2000?'color:red':''">{{huifu.length}}</span>
            <span>/2000</span>
          </div>
          <div class="button"
               @click="tohuifu2">
            <span>提交</span>
          </div>
        </div>
        <div class="sanjiao"></div>
      </div>
      <pagination :total="pageCount"
                  :limit="pageSize"
                  :page="pageIndex"
                  v-if="storeList.length!=0"
                  @page-change="pageChange"></pagination>
      <div v-if="storeList.length==0"
           style="width:100%;text-align: center;">
        <span>暂无留言消息</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tabIndex: 1,
      storeList: [],
      pageCount: 0,
      pageSize: 6,
      pageIndex: 1,
      huifu: '',
      mid: '',
      isHuifuNum: -1,
      uid: ''
    };
  },
  created () {
    this.GetMyStoreList()
  },
  methods: {
    GetMyStoreList () {
      this.httphelper.post('/api/CGPExpertApi/GetExpertMsgInfoList', {
        mMessage: '',
        mReceliveUserID: Number(localStorage.getItem('storeId')),
        page: this.pageIndex,
        limit: this.pageSize
      })
        .then(res => {
          if (res.data.code == 200) {
            this.storeList = res.data.data
            this.pageCount = res.data.totalcount
          }
        });
    },
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetMyStoreList()
    },
    shanchu (mid) {
      this.$confirm('您确定要删除本条留言吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.httphelper.post('/api/CGPExpertApi/DelExpertMsgInfo', {
          mid: mid
        })
          .then(res => {
            if (res.data.code == 200) {
              this.GetMyStoreList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    tohuifu (mid, mSendUserID, index) {
      if (this.isHuifuNum != -1) this.isHuifuNum = -1
      else {
        this.isHuifuNum = index
        this.mid = mid
        this.uid = mSendUserID
      }

    },
    tohuifu2 () {
      this.httphelper.post('/api/CGPExpertApi/SaveExpertMsgInfo', {
        mPId: this.mid,
        // mSendUserID: Number(localStorage.getItem('storeId')),
        mSendUserID: Number(JSON.parse(localStorage.getItem('ResData')).id),
        mReceliveUserID: this.uid,
        // mReceliveUserID: Number(JSON.parse(localStorage.getItem('ResData')).id),
        mReadFlag: 1,
        mMessage: this.huifu,
        mImageResID: '',
        mImageResUrl: ''
      })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            this.huifu = ''
          }
        });
    }
  }
};
</script>

<style scoped>
.tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 27px;
    margin-bottom: 30px;
}
.tabLeft {
    display: flex;
}
.tabBox {
    margin-right: 10px;
    width: 116px;
    height: 32px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    line-height: 32px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    /* cursor: pointer; */
}
.list .box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    position: relative;
}
.list .boxleft {
    width: 708px;
    background: #f7f7f8;
    padding: 20px 18px 20px 30px;
    box-sizing: border-box;
    display: flex;
}
.blbox1 img {
    width: 47px;
    height: 47px;
    border-radius: 50%;
    margin-right: 19px;
}
.blbox {
    display: flex;
    flex-direction: column;
    flex: 1;
}
.blbox .nicheng {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.blbox .neirong {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #353535;
    margin-top: 18px;
    margin-bottom: 20px;
}
.blboxbot {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.blboxbot .caozuo {
    display: flex;
    align-items: center;
}
.blboxbot img {
    margin-right: 10px;
}
.blboxbot span {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.boxright {
    flex: 1;
    margin-left: 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
.boxright img {
    max-width: 47%;
}
.hfbox {
    width: 668px;
    /* height: 191px; */
    background: #ffffff;
    border: 1px solid #f1f1f1;
    box-shadow: 10px 17px 30px 0px rgba(2, 29, 109, 0.1);
    position: absolute;
    top: 132px;
    left: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding-top: 15px;
    z-index: 100;
}
.hfbox textarea {
    width: 605px;
    height: 96px;
    background: #ffffff;
    border: 1px solid #d2d2d2;
    margin: 15px 30px 0;
    outline: none;
    resize: none;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #a9a9a9;
    padding: 16px;
    box-sizing: border-box;
}
.hfbox .zishu {
    position: absolute;
    bottom: 41px;
    right: 29px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #a9a9a9;
}
.hfboxs {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-left: 60px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #adadad;
}
.hfbox .button {
    width: 140px;
    height: 34px;
    background: #0b8586;
    border-radius: 17px;
    margin-top: 14px;
    margin-bottom: 16px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 34px;
    cursor: pointer;
}
.sanjiao {
    width: 0;
    height: 0;
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-bottom: 14px solid #ffffff;
    position: absolute;
    left: 570px;
    bottom: -1px;
}
</style>